<template>
  <div class="layout-header">
    <img class="layout-header-logo" :src="logoUrl" alt="" />
    <div v-if="!initing" class="layout-header-right">
      <span
        v-if="showRules"
        class="rules"
        @click="$router.push({ name: 'Rules' })"
      >
        参赛规则
      </span>

      <el-dropdown v-if="userInfo.nickname" @command="command">
        <span class="user">
          <img class="user-avatar" :src="userInfo.avatar" alt="" />
          <span class="user-name">{{ userInfo.nickname }}</span>
        </span>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="0">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <span v-else class="btn-login" @click="handleLogin">登录</span>
    </div>
  </div>
</template>

<script>
import { login, logout } from "../utils/login";
import { mapState } from "vuex";
import {
  Dropdown as ElDropdown,
  DropdownMenu as ElDropdownMenu,
  DropdownItem as ElDropdownItem,
} from "element-ui";
import "element-ui/lib/theme-chalk/dropdown.css";
import "element-ui/lib/theme-chalk/dropdown-menu.css";
import "element-ui/lib/theme-chalk/dropdown-item.css";

export default {
  name: "LayoutHeader",

  components: { ElDropdown, ElDropdownMenu, ElDropdownItem },

  data() {
    return {
      logoUrl: require("../assets/image/logo.png"),
      showRules: false,
    };
  },

  watch: {
    $route(to) {
      this.showRules = !["Home", "Rules"].includes(to.name);
    },
  },

  computed: {
    ...mapState(["initing", "userInfo"]),
  },

  methods: {
    handleLogin() {
      login();
    },
    command(e) {
      if (e === "0") {
        // 退出登录
        logout();
        window.location.reload();
      }
    },
  },
};
</script>

<style lang="less">
.layout-header {
  height: 50px;
  background-color: #811b26;
  display: none;
  color: @white;
  position: relative;
  overflow: hidden;
  font-size: 14px;
  align-items: center;
  justify-content: space-between;

  &-logo {
    display: inline-block;
    width: 101px;
    height: 27px;
    margin-left: 68px;
  }

  &-right {
    margin-right: 62px;
    display: flex;
    align-items: center;

    .rules {
      margin-right: 35px;
      cursor: pointer;
    }

    .user {
      display: inline-block;
      cursor: pointer;

      &-avatar {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        vertical-align: middle;
      }

      &-name {
        font-size: 14px;
        margin-left: 10px;
        vertical-align: middle;
        color: @white;
      }
    }

    .btn-login {
      cursor: pointer;
      padding: 10px;
    }
  }
}
</style>
